import React from 'react';
const UserContext = React.createContext({});
export { UserContext };
//# sourceMappingURL=User.js.map